import { localStorage } from 'shared/helper/storage';
import { RUBRIQ_FEATURES, RUBRIQ_FEATURE_SURVEY_THROTTLE_DAYS } from '../constants';
export var setFeatureSurveyLastShownAt = function setFeatureSurveyLastShownAt(feature, lastShownAt) {
  throwErrorIfFeatureInvalid(feature);
  return localStorage.set(keyFromFeature(feature), lastShownAt);
};
export var getFeatureSurveyLastShownAt = function getFeatureSurveyLastShownAt(feature) {
  throwErrorIfFeatureInvalid(feature);
  return localStorage.get(keyFromFeature(feature));
};
var throwErrorIfFeatureInvalid = function throwErrorIfFeatureInvalid(feature) {
  if (!Object.values(RUBRIQ_FEATURES).includes(feature)) {
    throw new Error("Invalid feature passed '".concat(feature, "'"));
  }
};
var keyFromFeature = function keyFromFeature(feature) {
  return "curie".concat(feature, "SurveyLastShownAt");
};
export var shouldShowFeatureFeedbackNotification = function shouldShowFeatureFeedbackNotification(feature, numberOfFeatureRunsUsed) {
  if (![RUBRIQ_FEATURES.EDITING, RUBRIQ_FEATURES.TRANSLATION].includes(feature)) {
    return false;
  }
  var surveyLastShownAt = getFeatureSurveyLastShownAt(feature);
  var surveyWasShownInThePast = !!surveyLastShownAt;
  var daysSinceSurveyLastShown = surveyWasShownInThePast ? (new Date().getTime() - new Date(surveyLastShownAt).getTime()) / (1000 * 60 * 60 * 24) : undefined;
  if (numberOfFeatureRunsUsed >= 2 && (!surveyWasShownInThePast || daysSinceSurveyLastShown >= RUBRIQ_FEATURE_SURVEY_THROTTLE_DAYS)) {
    return true;
  }
  return false;
};